<div class="container-timeline no-print" *ngIf="block && block.length">
    <div class="container">
        <div class="container-anchor">
            <app-sample-anchor [anchorItems]="itemsAnchor" [setOffset]="250" [scrollOnTop]="false"
                [styleHeader]="'second-timeline'"></app-sample-anchor>
        </div>
        <div *ngFor="let item of block; let idx = index" class="col-md-9 m-auto" [id]="'timeline-'+idx">
            <!-- DESKTOP -->
            <div class="container-timeline__single-timeline d-none d-lg-flex">
                <div class="container-timeline__single-timeline__box-marker col-3 col-md-2 col-lg-2 border-right-grey">
                    <div class="d-flex justify-content-between" *ngIf="splitDate(item.data_timeline).length === 1">
                        <p class="ls-h3-section-title text-brand-40 me-1" [innerHTML]="newDate[0]"></p>
                        <div class="border-right-green"></div>
                    </div>
                    <div class="d-flex justify-content-between w-100" *ngIf="splitDate(item.data_timeline).length > 1">
                        <div class="w-100 d-flex flex-column">
                            <p class="ls-h3-section-title text-brand-40" [innerHTML]="objDate.giorno"></p>
                            <p class="ls-h3-section-title text-brand-40" [innerHTML]="objDate.mese"></p>
                            <p class="ls-h3-section-title text-brand-40" [innerHTML]="objDate.anno"></p>
                        </div>
                        <div class="border-right-green"></div>
                    </div>
                </div>
                <div class="container-timeline__single-timeline__box-text rounded-3 mb-5 col-9 col-md-10 col-lg-10 d-flex">
                    <div class="container-timeline__single-timeline__box-text__general">
                        <h2 *ngIf="item.titolo"
                            class="container-timeline__single-timeline__box-text__general__title ls-h3-section-title text-neutral-30"
                            [ngClass]="{'title-responsive': item.immagine}" [innerHTML]="item.titolo"></h2>
                        <p *ngIf="item.testo_formattato"
                            class="container-timeline__single-timeline__box-text__general__text text-neutral-30 ls-p-small"
                            [ngClass]="{'text-responsive': item.immagine}" [innerHTML]="item.testo_formattato | safeHtml">
                        </p>
                    </div>
                    <div class="container-timeline__single-timeline__box-text__image col-4" *ngIf="item.immagine">
                        <img loading="lazy" [src]="domainWebsite + this.helperService.retrieveImage(item.immagine, 'src')"
                            [alt]="item.testo_alt">
                    </div>
                </div>
            </div>
            <!-- END DESKTOP -->
            <!-- MOBILE -->
            <div class="d-flex flex-column d-lg-none container-timeline__single-timeline-mobile border-left-grey">
                <div class="d-flex" *ngIf="splitDate(item.data_timeline).length === 1">
                    <div class="border-left-green"></div>
                    <p class="ls-h3-section-title text-brand-40 ms-3" [innerHTML]="newDate[0]"></p>
                </div>
                <div class="d-flex" *ngIf="splitDate(item.data_timeline).length > 1">
                    <div class="border-left-green"></div>
                    <div class="d-flex ms-3">
                        <p class="ls-h3-section-title text-brand-40 me-2" [innerHTML]="objDate.giorno"></p>
                        <p class="ls-h3-section-title text-brand-40 me-2" [innerHTML]="objDate.mese"></p>
                        <p class="ls-h3-section-title text-brand-40" [innerHTML]="objDate.anno"></p>
                    </div>
                </div>
                <div class="ms-3">
                    <div>
                        <div class="container-timeline__single-timeline-mobile__box-text__general">
                            <h2 *ngIf="item.titolo"
                                class="container-timeline__single-timeline-mobile__box-text__general__title ls-h3-section-title text-neutral-30"
                                [innerHTML]="item.titolo">
                            </h2>
                            <p *ngIf="item.testo_formattato"
                                class="container-timeline__single-timeline-mobile__box-text__general__text text-neutral-30 ls-p-small"
                                [innerHTML]="item.testo_formattato | safeHtml">
                            </p>
                        </div>
                        <div class="container-timeline__single-timeline-mobile__box-text__image" *ngIf="item.immagine">
                            <img loading="lazy" [src]="domainWebsite + this.helperService.retrieveImage(item.immagine, 'src')"
                                [alt]="item.testo_alt">
                        </div>
                    </div>
                </div>
            </div>
            <!-- END MOBILE -->
        </div>
    </div>
</div>
<ng-container *ngFor="let item of block; let idx = index">
    <app-sample-print 
        [title]="item.titolo" 
        [subtitle]="item.data_timeline" 
        [description]="item.testo_formattato" 
        [imageUrl]="item.immagine ? (domainWebsite + this.helperService.retrieveImage(item.immagine, 'src')) : ''">
    </app-sample-print>
</ng-container>